"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnPiles = void 0;
class ColumnPiles {
    constructor(...piles) {
        if (piles.length !== 4) {
            throw new Error("ColumnPiles must be initialized with exactly 4 piles.");
        }
        this.piles = piles;
    }
    clone() {
        const pilesCopy = this.piles.map((p) => p.clone());
        return new ColumnPiles(...pilesCopy);
    }
    getPileByPileId(pileId) {
        const found = this.piles.find((p) => p.id === pileId);
        if (!found) {
            throw new Error(`Pile not found for id: ${pileId}`);
        }
        return found;
    }
    getPileByCardIndex(index) {
        const pile = this.piles.find((p) => p.containsCardIndex(index));
        if (!pile) {
            throw new Error(`Pile not found that contains card with index: ${index}`);
        }
        return pile;
    }
    getPileByCardId(cardId) {
        return this.piles.find((p) => p.containsCardId(cardId));
    }
    combine(cards) {
        for (const pile of this.piles) {
            pile.combine(cards);
        }
    }
}
exports.ColumnPiles = ColumnPiles;
